import { MasterData, ModelVariantTree } from "../../api/models";
import { MasterDataContainer } from "../../validators/mater-data-container";
import {
  createAction,
  createActionWithPayload,
  IAction,
  IActionWithPayload,
} from "../utils";

const ACTION_REQUEST_MASTER_DATA = "MASTER_DATA/REQUEST";
const ACTION_LOADED_MASTER_DATA = "MASTER_DATA/LOADED";
const ACTION_ERROR_MASTER_DATA = "MASTER_DATA/ERROR";

export interface MasterDataState {
  data?: MasterData;
  modelVariants?: ModelVariantTree[];
  loaded?: boolean;
  loading?: boolean;
  error?: any;
}

const initialState: MasterDataState = {
  loaded: false,
  loading: false,
};

type RequestMasterDataActionType = IAction<typeof ACTION_REQUEST_MASTER_DATA>;
type MasterDataLoadedActionType = IActionWithPayload<
  typeof ACTION_LOADED_MASTER_DATA,
  MasterData
>;
type MasterDataErrorActionType = IActionWithPayload<
  typeof ACTION_ERROR_MASTER_DATA,
  any
>;

type Actions =
  | RequestMasterDataActionType
  | MasterDataLoadedActionType
  | MasterDataErrorActionType;

export const requestMasterDataAction = (): RequestMasterDataActionType => {
  return createAction(ACTION_REQUEST_MASTER_DATA);
};

export const masterDataLoadedAction = (
  data: MasterData
): MasterDataLoadedActionType => {
  return createActionWithPayload(ACTION_LOADED_MASTER_DATA, data);
};

export const masterDataErrorAction = (
  error: any
): MasterDataErrorActionType => {
  return createActionWithPayload(ACTION_ERROR_MASTER_DATA, error);
};

// reducer
export const masterDataReducer = (
  state: MasterDataState = initialState,
  action: Actions
): MasterDataState => {
  switch (action.type) {
    case ACTION_REQUEST_MASTER_DATA:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case ACTION_LOADED_MASTER_DATA:
      MasterDataContainer.data = {
        ...action.payload,
        showrooms: MasterDataContainer.data?.showrooms ?? [],
        salesPersons: MasterDataContainer.data?.salesPersons ?? [],
        crmAgents: MasterDataContainer.data?.crmAgents ?? [],
      };
      return {
        ...state,
        loaded: true,
        loading: false,
        data: action.payload,
      };
    case ACTION_ERROR_MASTER_DATA:
      return {
        ...state,
        loaded: true,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
